import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-book-shelf',
  templateUrl: './video-book-shelf.component.html',
  styleUrls: ['./video-book-shelf.component.css']
})
export class VideoBookShelfComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/video-book-shelf/video-book-shelf.component.ts